module.exports = __webpack_public_path__ + "img/snake_control_left.dc679586.svg";